/**
 * Convert a human label or identifier to snake_case.
 *   "First Name"        → "first_name"
 *   "targetMemberName"  → "target_member_name"
 *   "URLPath"           → "url_path"
 *
 * camelCase/PascalCase boundaries are split BEFORE separators are collapsed, so a
 * value typed as `targetMemberName` is normalized the same way the runtime
 * canonicalizes variable names — keeping authored output names aligned with how
 * captures are stored and referenced (see canonicalizeVariableName in
 * @chatsdet/types).
 */
export function labelToSnakeName(label: string): string {
  return label
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
    .replace(/[^A-Za-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toLowerCase();
}

/** Ensure `base` is unique among `existing` names by appending _2, _3, etc. */
export function uniqueName(base: string, existing: string[]): string {
  if (!existing.includes(base)) return base;
  let i = 2;
  while (existing.includes(`${base}_${i}`)) i++;
  return `${base}_${i}`;
}
